import "../App.css";

import logo from "../assets/images/logo.png";
import x from "../assets/images/x-light.png";
import telegram from "../assets/images/telegram-light.png";

function Footer() {

    return (

        <footer className="footer">

            <div className="container">

                <div className="footer-banner">

                    <div className="footer-overlay">

                        <div></div>

                        <div className="footer-center">

                            <img
                                src={logo}
                                alt="Sky Goose"
                            />

                            <h3>SKY GOOSE</h3>

                            <p>THE CRYPTO AIRLINE</p>

                        </div>

                        <div className="footer-social">

                            <a
                                href="https://x.com/flyskygoose"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={x} alt="" />
                            </a>

                            <a
                                href="https://t.me/flyskygoose"
                                target="_blank"
                                rel="noreferrer"
                            >
                                <img src={telegram} alt="" />
                            </a>

                        </div>

                    </div>

                </div>

                <div className="footer-bottom">

                    <p>

                        © 2026 Sky Goose. All rights reserved.

                    </p>

                    <a href="mailto:airline@skygoose.wtf">

                        airline@skygoose.wtf

                    </a>

                </div>

            </div>

        </footer>

    );

}

export default Footer;